module.exports = __webpack_public_path__ + "img/analytics_btn.23ce7bbc.svg";